export const environment = {
	production: false,
	baseUrl: 'https://apipp.360city.pt/clean/',
	app: '360City - Clean',
	version: '1.0.0-23'
};
